import { useState } from 'react';
import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { FloatingNav } from './FloatingNav';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: '#0a0a0f' }}>
      {/* Ambient glow */}
      <div className="ambient-glow" />

      {/* Film grain overlay */}
      <div className="film-grain" />

      {/* Sidebar - hidden on mobile, shown as overlay when mobileSidebarOpen */}
      <div
        className={`
          fixed inset-0 z-40 lg:relative lg:inset-auto
          ${mobileSidebarOpen ? 'block' : 'hidden lg:block'}
        `}
      >
        {/* Mobile backdrop */}
        {mobileSidebarOpen && (
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm lg:hidden"
            onClick={() => setMobileSidebarOpen(false)}
          />
        )}

        {/* Sidebar container */}
        <div
          className={`
            relative h-full
            transition-all duration-200 ease-in-out
            ${sidebarCollapsed ? 'w-16' : 'w-64'}
            lg:static
          `}
        >
          <Sidebar
            collapsed={sidebarCollapsed}
            onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
            onClose={() => setMobileSidebarOpen(false)}
          />
        </div>
      </div>

      {/* Main content area */}
      <div className="flex flex-1 flex-col overflow-hidden relative z-10">
        <Header
          onMenuClick={() => setMobileSidebarOpen(true)}
          sidebarCollapsed={sidebarCollapsed}
        />

        {/* Page content with bottom padding for floating nav */}
        <main className="flex-1 overflow-auto pb-20">
          {children}
        </main>
      </div>

      {/* Floating navigation toolbar */}
      <FloatingNav />
    </div>
  );
}
